import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Section } from '../Section';
import { DEMO_SCRIPTS, TAG_TONE } from '../../data/howDemo';
function XMark() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--red)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-170" data-mp="30aeaq1syt0yx">
      <path d="M18 6 6 18M6 6l12 12" data-id="element-171" data-mp="349m142ovxbd6" />
    </svg>;
}
function Check() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--green)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" data-id="element-172" data-mp="27n0mcs3c1dqf">
      <path d="M20 6 9 17l-5-5" data-id="element-173" data-mp="2glvui9pxsxwd" />
    </svg>;
}

/**
 * Section 02 plus the demo window beneath it. Loads on the ungoverned draft;
 * the red button swaps the whole window to the governed one. No animation.
 */
export function TryIt() {
  const [idx, setIdx] = useState(0);
  const [governed, setGoverned] = useState(false);
  const s = DEMO_SCRIPTS[idx];
  const pick = (i: number) => {
    setIdx(i);
    setGoverned(false);
  };
  return <>
      <Section n="02" label="Try it" className="tryit" data-id="element-174" data-mp="ujqtkh08jckt">
        <h2 className="h2" data-id="element-175" data-mp="pjm8sesanvos">Same prompt. Two outcomes.</h2>
        <p className="lede" data-id="element-176" data-mp="krupmpbgws8o">The difference is what the model is told, before a single token is spent.</p>
        <div className="tabs" role="group" aria-label="Choose a scenario" data-id="element-177" data-mp="ft1c4ww6l18i">
          <span className="tabs-l" data-id="element-178" data-mp="fqngaltofkzw">TRY IT:</span>
          {DEMO_SCRIPTS.map((d, i) => <button key={d.id} type="button" className={`tab${i === idx ? ' on' : ''}`} aria-pressed={i === idx} onClick={() => pick(i)} data-id="element-179" data-mp="arkct5tchmu1" data-mpi={i}>
              {d.tab}
            </button>)}
        </div>
      </Section>

      <div className="demo" data-id="element-180" data-mp="3sz9tr2d8j0ih">
        <div className="demo-src" data-id="element-181" data-mp="3t034sfj88c6f">{s.source}</div>
        <div className="win" data-id="element-182" data-mp="3t1e8kfco9jxj">
          <div className="win-bar" data-id="element-183" data-mp="1w6rhs82y7xk9">
            <div className="dots" aria-hidden="true" data-id="element-184" data-mp="1w5ouea4u4d93">
              <i data-id="element-185" data-mp="1r86ge5byn7u8" />
              <i data-id="element-186" data-mp="1r7n9rkrrg5vi" />
              <i data-id="element-187" data-mp="1r984pbhzlqtw" />
            </div>
            <div className="win-url" data-id="element-188" data-mp="1r5u4o9wsptpm">
              app.meetsynthia.ai<span data-id="element-189" data-mp="3ln3szb3ukx9k">/</span>
              {s.workflow}
            </div>
            <div className="win-live" data-id="element-190" data-mp="3qelnphfa21m3">
              <i aria-hidden="true" data-id="element-191" data-mp="3qgesssa8sdrz" />
              LIVE
            </div>
          </div>

          <div className="win-ask" data-id="element-192" data-mp="3bra9f7rpo3ia">
            <div className="who" data-id="element-193" data-mp="3bnuvw9dor2iz">{s.who}</div>
            <div className="q" data-id="element-194" data-mp="3go94ptn42gi2">{s.prompt}</div>
            {!governed && <button type="button" className="send" onClick={() => setGoverned(true)} data-id="element-195" data-mp="89icrg2mqvdr">
                {s.send}
              </button>}
          </div>

          <div aria-live="polite" data-id="element-196" data-mp="d692kv48l5cd">
            {!governed ? <>
                <div className="win-g" data-id="element-197" data-mp="3ufxc5jmf0gsp">
                  <div className="win-l" data-id="element-198" data-mp="3a5ocqw41g92">
                    <div className="win-h" data-id="element-199" data-mp="38umiwm86ikl">WITHOUT SYNTHIA</div>
                    <div className="draft" data-id="element-200" data-mp="2j1jskqyp2nih">
                      {s.without.map((seg, i) => seg.bad ? <mark key={i} className="bad" data-id="element-201" data-mp="2o166z3q9e9sv">
                            {seg.x}
                          </mark> : <span key={i} data-id="element-202" data-mp="113neld1zgiks">{seg.x}</span>)}
                    </div>
                  </div>
                  <div className="win-r" data-id="element-203" data-mp="1f24yezorpaxf">
                    <div className="win-h" data-id="element-204" data-mp="1b1uvxx06p2nb">WHAT IT SKIPPED</div>
                    {s.skipped.map(t => <div className="xrow" key={t} data-id="element-205" data-mp="nc0j3ffv7e32">
                        <XMark data-id="element-206" data-mp="ncs7o6b1obju" />
                        <span data-id="element-207" data-mp="id5svsfkin8x">{t}</span>
                      </div>)}
                  </div>
                </div>
                <div className="strip red" data-id="element-208" data-mp="w4u0pjisapk3">
                  <span data-id="element-209" data-mp="w6onz4hj2trc">{s.missed}</span>
                </div>
              </> : <>
                <div className="win-g" data-id="element-210" data-mp="rc10n8y9g5ec">
                  <div className="win-l" data-id="element-211" data-mp="3n7xosj80xa8">
                    <div className="win-h" data-id="element-212" data-mp="3m6kaheqfypc">
                      <i className="gdot" aria-hidden="true" data-id="element-213" data-mp="3vsvd05eopo50" />
                      WITH SYNTHIA
                    </div>
                    <div className="draft" data-id="element-214" data-mp="cd855oj53dae">
                      {s.with.map((p, i) => <p key={i} data-id="element-215" data-mp="hc1ingyff4ak" data-mpi={i}>{p}</p>)}
                    </div>
                  </div>
                  <div className="win-r told" data-id="element-216" data-mp="m8ib2ncns4tg">
                    <div className="win-h" data-id="element-217" data-mp="r0jinvyvt7d5">WHAT THE MODEL WAS TOLD</div>
                    {s.told.map(t => <div className="crow" key={t.rule} data-id="element-218" data-mp="w0fps42vlewx">
                        <Check data-id="element-219" data-mp="w1z6twwcvtzr" />
                        <span className="tag" style={{
                    color: TAG_TONE[t.tag],
                    borderColor: TAG_TONE[t.tag]
                  }} data-id="element-220" data-mp="100yg1tp4ecx0">
                          {t.tag}
                        </span>
                        <span className="r" data-id="element-221" data-mp="19zno6ur7sj02">{t.rule}</span>
                      </div>)}
                    <div className="mini-rcpt" data-id="element-222" data-mp="36s7cvjmigls9">
                      <div className="rh" data-id="element-223" data-mp="36tig9ic1nriu">
                        <span data-id="element-224" data-mp="3br0t3jt6mqw4">/ INSTRUCTION RECEIPT</span>
                        <span data-id="element-225" data-mp="3brk9gw36p781">{s.receiptId}</span>
                      </div>
                      <div className="kv bb" data-id="element-226" data-mp="348ks0vza9prb">
                        <span className="k" data-id="element-227" data-mp="349cd3cv9853c">rules</span>
                        <span style={{
                      color: 'var(--green)',
                      fontWeight: 500
                    }} data-id="element-228" data-mp="2zfrm44s2wbdn">{s.told.length}/{s.told.length} included</span>
                        <span className="k" data-id="element-229" data-mp="2uhzk2hxpz8vq">workflow</span>
                        <span data-id="element-230" data-mp="2pjelso212z9x">{s.workflow}</span>
                        <span className="k" data-id="element-231" data-mp="2pgingym9q8ky">source</span>
                        <span data-id="element-232" data-mp="3n5c9r0z6fwt9">{s.source}</span>
                        <span className="k" data-id="element-233" data-mp="3n415l01tkn1m">passes</span>
                        <span data-id="element-234" data-mp="3i8ltacjgmz7b">{s.passes}</span>
                      </div>
                      <div className="kv" data-id="element-235" data-mp="3d7oapyujg35a">
                        <span className="k" data-id="element-236" data-mp="3d6cwt67dpf0g">algorithm</span>
                        <span data-id="element-237" data-mp="389w92d43d2nw">ed25519</span>
                        <span className="k" data-id="element-238" data-mp="388uzye6myq8t">digest</span>
                        <span className="ell" data-id="element-239" data-mp="21tar566ti9v2">{s.digest}</span>
                        <span className="k" data-id="element-240" data-mp="21qockmlieu3c">2026-09-24</span>
                        <span className="sig" data-id="element-241" data-mp="1wsedi0wnz9cg">
                          <span data-id="element-242" data-mp="ouimcix162np">14:02:11 UTC</span>
                          <span className={`signed${s.stamp === 'HELD' ? ' held' : ''}`} data-id="element-243" data-mp="ov0i7efs6ev3">{s.stamp}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={`strip ${s.stamp === 'HELD' ? 'amber' : 'green'}`} data-id="element-244" data-mp="eyp2eegzf6vw">
                  <span data-id="element-245" data-mp="jtkzht12skfv">{s.done}</span>
                  <button type="button" onClick={() => setGoverned(false)} data-id="element-246" data-mp="56rnawmururw">
                    ← See it without
                  </button>
                </div>
              </>}
          </div>

          <div className="win-foot" data-id="element-247" data-mp="3sbr28x876sfs">
            <div className="t" data-id="element-248" data-mp="3scsidg42m54d">Same prompt. Same model. One of these becomes Exhibit A.</div>
            <Link className="btn btn-o" to="/#atomizer" style={{
            height: 40,
            fontSize: 14,
            padding: '0 16px'
          }} data-id="element-249" data-mp="15pmibdafant">
              See it on a real document <span className="mono" data-id="element-250" data-mp="3nc4rcufudoa5">↓</span>
            </Link>
          </div>
        </div>
      </div>
    </>;
}